import { DealershipCapacityRoutingModule } from './dealership-capacity-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealershipCapacityComponent } from './dealership-capacity.component';
import { SharedModule } from '../../shared/shared.module';
import { ShopMaxComponent } from './shop-max/shop-max.component';
import { TechnicianGridComponent } from './technician-grid/technician-grid.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    DealershipCapacityComponent,
    ShopMaxComponent,
    TechnicianGridComponent
  ],
  imports: [
    CommonModule,
    DealershipCapacityRoutingModule,
    SharedModule,
    TranslateModule
  ],
  exports:[TranslateModule],
})
export class DealershipCapacityModule { }
